import apiClient from '../../apiClient';
import { URL_TMVCS } from '../../util/errorString';

import { Content, ContentResponse, KeyValue } from './type';

const fetchResourceData = async (): Promise<Content> => {
  //const API_ENDPOINT = 'https://qm07-gw-dmz-mm-proxy-pse-api-v1.apps.vacationclub.io/proxy/pse/v1/getStaticContent';
  //const API_ENDPOINT = 'https://id01-gw-dmz-mm-proxy-pse-api-v1.apps.vacationclub.io/proxy/pse/v1/getStaticContent';
  const API_ENDPOINT = `${process.env.REACT_APP_API_DOMAIN}${process.env.REACT_APP_CONTENT_API_PATH}`;
  const brandName = URL_TMVCS;
  const apiURL = `${API_ENDPOINT}?brandName=${brandName}`;
  let response: any;
  let contentData: KeyValue;
  try {
    response = await apiClient.get<ContentResponse>(apiURL);
    contentData = response?.success ? response.data : (await import('./localized-content-en-tmvcs.json')).default.data;
  } catch (e: any) {
    contentData = (await import('./localized-content-en-tmvcs.json')).default.data;
  }

  const images = Object.keys(contentData)
    .filter(function (k) {
      return k.indexOf('preview-sales-engine.static-content.images') === 0;
    })
    .reduce(function (newData, k) {
      // @ts-ignore
      newData[k] = contentData[k];
      return newData;
    }, {});

  const copy = Object.keys(contentData)
    .filter(function (k) {
      return k.indexOf('preview-sales-engine.static-content.copy') === 0;
    })
    .reduce(function (newData, k) {
      // @ts-ignore
      newData[k] = contentData[k];
      return newData;
    }, {});

  return {
    messages: copy,
    images: images,
  };
};

export default fetchResourceData;
